
import { Link } from "react-router-dom";
import { Utils } from "../../../../utils/Utils";
import DetailAccentCard from "../../../common/detail/DetailAccentCard";

export default function EnrollSection({ workshop }) {
	const priceToman = Utils.convertTomanComma(workshop.price);

	return (
		<DetailAccentCard bodyClassName="p-5" ariaLabel="ثبت‌نام کارگاه">
			{workshop.price ? (
				<>
					<p className="font-Vazir-500 text-[13px] text-darkBlue/55 text-center">
						هزینه کارگاه
					</p>
					<p className="mt-1 text-center font-Vazir-700 text-[22px] text-cta">
						{priceToman}
						<span className="mr-1 font-Vazir-500 text-[13px] text-darkBlue/55">
							تومان
						</span>
					</p>
					<div className="mt-5 flex justify-center">
						{workshop.is_enroll ? (
							<span className="rounded-[12px] bg-lightCta px-4 py-2.5 font-Vazir-600 text-[14px] text-darkBlue">
								ثبت‌نام شده
							</span>
						) : (
							<Link
								to={`/workshop_purchase/${workshop.id}/`}
								className="inline-flex min-h-[44px] items-center justify-center rounded-[12px] px-6 font-Vazir-600 text-[14px] text-white no-underline bg-gradient-to-l from-cta to-[#FF825E] shadow-[0_4px_14px_rgba(255,106,75,0.35)] hover:brightness-105 transition"
							>
								ثبت‌نام در کارگاه
							</Link>
						)}
					</div>
				</>
			) : (
				<div className="text-center">
					<span className="inline-block rounded-[12px] bg-lightCta px-4 py-2 font-Vazir-700 text-[15px] text-darkBlue">
						رایگان
					</span>
				</div>
			)}
		</DetailAccentCard>
	);
}
